import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from './Text';
import { Spacer } from './Spacer';
import IconTimer from './icons/IconTimer';
const TimeInfo = ({ title }) => (<View style={styles.row}>
    <IconTimer height={16} width={16} colorKey="brand"/>
    <Spacer w={4}/>
    <View style={styles.flex}>
      <Text Text-14 Primary>
        {title}
      </Text>
    </View>
  </View>);
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
});
export default TimeInfo;
